module.exports = __webpack_public_path__ + "media/images/honors_program_hero-f19dcfe3abec17cb8f1022d0720c2ec8.jpg";